import { FormValidators } from '@servicetitan/form';

export function passwordIsValidFormat(value: string) {
    return (
        value.length >= 10 &&
        FormValidators.hasLowerCase(value) &&
        FormValidators.hasUpperCase(value)
    );
}
